//@ts-check

import React from "react";
import ScrollContent from 'components/ScrollContent';
import useTypedSelector from "utils/useTypedSelector";
import AboutCourseWidget from './AboutCourseWidget';
import CourseAccessWidget from './CourseAccessWidget';
import NotificationsWidget from './NotificationsWidget';
import ResultsWidget from './ResultsWidget';
import classes from "./dashboard.module.scss";
import FeedbackWidget from "./FeedbackWidget";
import WaitRipple from "components/WaitRipple";

/**
 * Dashboard
 * @module features/classes/Dashboard/Dashboard
 * @return a wrapper for available Dashboard widgets.
 */
const CustomDashboard = () => {

    const { currentClass } = useTypedSelector(state => state.classData);

    /**
     * @type {import("../Classes").StudentClassDtoForAny}
     */
    const dashBoardData = currentClass.DashBoardData.StudentData;

    console.log("CustomDashboard", dashBoardData);

    if( !dashBoardData.StudentClass.Name || dashBoardData.StudentClass.Name === "" ){
        return <WaitRipple />;
    }
 
    return (
        <ScrollContent scrollname="class-dashboard" >
            <div className={`${classes.dashboard_container} ${classes.custom}`}>
              <AboutCourseWidget Data={dashBoardData} />
              <ResultsWidget data={dashBoardData} />

              { currentClass.notifications && currentClass.notifications.length > 0 &&
                <NotificationsWidget classId={currentClass.Id} notifications={currentClass.notifications} CanEdit={currentClass.CanEditNotifications} />
              }

            <CourseAccessWidget  isTeacher={false} StudentData={dashBoardData}  />
            <FeedbackWidget  data={currentClass.FeedbackData} />


            </div>
        </ScrollContent>
    )
}

export default CustomDashboard;
